import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForEAtoOSBFreeWithPDE(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		canUpgrade,
		changeOfferingToStandardExperienceUrl,
		isInCollection,
		hasPaymentDetailsEntered,
	} = context;

	const isEligibleNonCollectionProduct =
		isInCollection === 'NOT_IN_COLLECTION' &&
		isProductOneOf(product, ['jira', 'jira-product-discovery', 'confluence']);
	const isEligibleCollectionAgnosticProduct = isProductOneOf(product, ['jira-service-management']);

	return Boolean(
		isEditionOneOf(edition, ['free']) &&
		canUpgrade &&
		hasPaymentDetailsEntered &&
		changeOfferingToStandardExperienceUrl &&
		(isEligibleNonCollectionProduct || isEligibleCollectionAgnosticProduct),
	);
}
